<template>
  <router-btn :text="$t('servicesystem.common_objects.document.attach_to_job')" :icon="'mdi-paperclip'" :color="'quaternary'"
    :loading="loading" :disabled="false" :textbtn="textbtn" :large="large" :small="small" @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";
import ClientAPIMixin from "@/api/ClientAPIMixin";

export default {
  name: "AttachServiceReportBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },
  mixins: [ClientAPIMixin],

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    async action() {
      this.loading = true;
      await this.generateAndSaveReport(this.jobId);
      this.loading = false;
      this.$store.state.triggerevents.refreshDocumentsTrigger++;
    },
  },

  computed: {
    jobId() {
      return parseInt(this.$route.params.jobId) || null;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
